import React, { useState } from 'react';
import {
  FaMapMarkerAlt, FaPhone, FaClock, FaHospital, FaEnvelope,
  FaFileMedical, FaBrain, FaFileAlt, FaPills, FaCheckCircle, FaArrowRight
} from 'react-icons/fa';

const Contact = () => {
  const [form, setForm] = useState({ name: '', phone: '', issue: '', time: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.name && form.phone) {
      try {
        // Note: Update this URL to point to where your PHP script is actually hosted
        const response = await fetch('https://drrahulnaikneurologist.com/api/?action=book_appointment', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(form),
        });
        const result = await response.json();
        if (result.success) {
          setSubmitted(true);
        } else {
          alert('Failed to book appointment: ' + result.message);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('An error occurred. Please try again later.');
      }
    }
  };

  return (
    <div className="contact-page">

      {/* ── PAGE HERO ── */}
      <section className="page-hero">
        <div className="page-hero-bg-dots" />
        <div className="container">
          <div className="page-hero-content">
            <div className="section-tag">Get In Touch</div>
            <h1 className="page-hero-title">Book an Appointment</h1>
            <p className="page-hero-sub">
              Consult Dr. Rahul Naik at Naik Neuro Clinic, Nashik — Mon to Sat, Morning & Evening slots available.
            </p>
          </div>
        </div>
      </section>

      {/* ── CONTACT GRID ── */}
      <section className="contact-main-section">
        <div className="container">
          <div className="contact-grid">

            {/* Info column */}
            <div className="contact-info">
              <div className="contact-info-header">
                <div className="section-tag">Clinic Details</div>
                <h2 className="contact-info-title">Naik Neuro Clinic</h2>
                <p className="contact-info-sub">Expert neurological care in Nashik — walk-ins welcome, appointments preferred.</p>
              </div>
              <div className="contact-details">
                {[
                  { icon: <FaMapMarkerAlt size={17} />, label: 'Location',  val: 'Nashik, Maharashtra' },
                  { icon: <FaPhone size={16} />,        label: 'Phone',     val: '+91 9822180184' },
                  { icon: <FaClock size={16} />,        label: 'OPD Hours', val: 'Mon–Sat: 10am–2pm, 5pm–8pm' },
                  { icon: <FaHospital size={16} />,     label: 'Emergency', val: 'Available on call 24/7' },
                  { icon: <FaEnvelope size={16} />,     label: 'Email',     val: 'info@naikneuroclinic.com' },
                ].map(({ icon, label, val }) => (
                  <div key={label} className="contact-detail-item">
                    <span className="contact-detail-icon">{icon}</span>
                    <div>
                      <div className="contact-detail-label">{label}</div>
                      <div className="contact-detail-val">{val}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="contact-schedule-card">
                <h4 className="schedule-card-title"><FaClock size={14} style={{marginRight:7}} />OPD Schedule</h4>
                <div className="schedule-row">
                  <span className="schedule-day">Monday – Saturday</span>
                  <span className="schedule-time">10:00 AM – 2:00 PM</span>
                </div>
                <div className="schedule-row">
                  <span className="schedule-day">Monday – Saturday</span>
                  <span className="schedule-time">5:00 PM – 8:00 PM</span>
                </div>
                <div className="schedule-row schedule-closed">
                  <span className="schedule-day">Sunday</span>
                  <span className="schedule-time">Closed</span>
                </div>
                <p className="schedule-note">For emergencies, please call the clinic directly at any hour.</p>
              </div>
            </div>

            {/* Form column */}
            <div className="contact-form-wrap">
              {!submitted ? (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <h3 className="form-title">Request Appointment</h3>
                  <p className="form-subtitle">Fill in your details and we'll confirm your slot shortly.</p>
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input type="text" name="name" placeholder="Your full name" value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input type="tel" name="phone" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label>Neurological Concern</label>
                    <select name="issue" value={form.issue} onChange={handleChange}>
                      <option value="">Select a concern</option>
                      <option value="stroke">Stroke / Cerebrovascular</option>
                      <option value="epilepsy">Epilepsy / Seizures</option>
                      <option value="movement">Movement Disorders / Parkinson's</option>
                      <option value="memory">Memory / Dementia</option>
                      <option value="headache">Headache / Migraine</option>
                      <option value="neuropathy">Neuropathy</option>
                      <option value="ms">Multiple Sclerosis</option>
                      <option value="eeg">EEG / NCS / EMG Test</option>
                      <option value="other">Other Neurological Issue</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Preferred Time Slot</label>
                    <select name="time" value={form.time} onChange={handleChange}>
                      <option value="">Select time slot</option>
                      <option value="morning">Morning (10am – 2pm)</option>
                      <option value="evening">Evening (5pm – 8pm)</option>
                    </select>
                  </div>
                  <button type="submit" className="btn-primary form-submit">
                    Confirm Appointment Request <FaArrowRight size={12} style={{marginLeft:8}} />
                  </button>
                  <p className="form-privacy">We respect your privacy. Your details are only used to confirm your appointment.</p>
                </form>
              ) : (
                <div className="form-success">
                  <div className="form-success-icon"><FaCheckCircle size={52} color="var(--teal)" /></div>
                  <h3>Appointment Request Sent!</h3>
                  <p>Thank you, <strong>{form.name}</strong>. Our clinic will call you shortly to confirm your slot at Naik Neuro Clinic, Nashik.</p>
                  <button className="btn-secondary" onClick={() => setSubmitted(false)}>Book Another Appointment</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      

      {/* ── Google Map ── */}
      <section className="map-section">
        <div className="container">
          <div className="map-header">
            <div className="section-tag">Location</div>
            <h3 className="map-title">Find Us on Map</h3>
            <p className="map-subtitle">Visit Naik Neuro Clinic at our Nashik location</p>
          </div>
          <div className="map-container">
            <iframe
              title="Naik Neuro Clinic Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.469228243865!2d73.77883867427644!3d19.988811822685058!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeb62ac6ce287%3A0x3b1d1c3731098457!2sDr%20Rahul%20Naik%20-%20Neurologist%20%2F%20Stroke%20%2F%20Migraine%20%2F%20Epilepsy%20%2F%20Dementia%20%2F%20Movement%20Disorders%20%2F%20Neuropathy%20%2F%20Myopathy!5e0!3m2!1sen!2sin!4v1775631871860!5m2!1sen!2sin"
              width="100%"
              height="420"
              style={{ border: 0, borderRadius: 16 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;
